import { useNavigate, useParams } from "react-router-dom";
import { useDetails } from "../../hooks";
import { NetworkTabs } from "./DetailTabs/NetworkTabs";
import { NetworkKeyMetricsRow } from "./NetworkKeyMetricsRow";
import { NetworkKeyStatsCard } from "./NetworkKeyStatsCard";
import { NetworkProfileCard } from "./NetworkProfileCard";
import { NetworkQuickActionsSidebar } from "./NetworkQuickActionsSidebar";

export default function NetworkDetail() {
  const { id } = useParams();
  const { data: networkData } = useDetails({ networkId: id || "" });
  const networkInfo = networkData?.result;
  const navigate = useNavigate();
  const mappedData = {
    id: id || "",
    networkId: networkInfo?.networkNo || "",
    networkName: networkInfo?.networkName || "",
    networkType: networkInfo?.networkType || "",
    dateEstablished:
      networkInfo?.commissionDate || networkInfo?.createdDate || "",
    physicalAddress: networkInfo?.location || "",
    geoLocation: "",
    description: networkInfo?.description || "",
    serviceAreas: [],
    currentCapacity: {
      current: parseFloat(networkInfo?.currentThroughput || "0"),
      max: parseFloat(networkInfo?.designCapacity || "0"),
      unit: "MLD",
    },
    conditionScore: networkInfo?.conditionScore || 0,
    riskScore: networkInfo?.riskScore,
    efficiency: networkInfo?.serviceLevelAchievement || 0,
    age: networkInfo?.networkAgeYears || 0,
    criticalAlerts: networkInfo?.activeAlerts || 0,
    totalAssets: networkInfo?.totalAssets || 0,
    operationalPerformance: networkInfo?.capacityUtilization || 0,
    status: networkInfo?.operationalStatusDisplay ?? "NA",
    contact: networkInfo?.contactName ?? "NA",
    contactPerson: networkInfo?.contactPerson ?? "NA",
    riskStatus: networkInfo?.riskStatus ?? "NA",
  };

  return (
    <div>
      <div className="max-w-[1400px] mx-auto space-y-6">
        {/* Grid Layout - Main Content Area */}
        <div className="grid grid-cols-12 lg:grid-cols-12 gap-6">
          {/* Left Column - Main Content (spans 3 columns on large screens) */}

          <div className="lg:col-span-8 space-y-6">
            <NetworkProfileCard data={mappedData} />
            <NetworkKeyMetricsRow data={mappedData} />
          </div>

          {/* Right Column - Sidebar (spans 1 column on large screens) */}
          <div className="lg:col-span-4 space-y-4">
            <NetworkKeyStatsCard data={mappedData} />
            <NetworkQuickActionsSidebar data={mappedData} />
          </div>
        </div>

        {/* Full Width Tabs Section */}
        <NetworkTabs networkData={mappedData} data={networkData} />
      </div>
    </div>
  );
}
